import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import { mockData } from '../mockData';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export const BrandPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  const brandData = mockData.brandDetails[slug];

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, [slug]);

  if (!brandData) {
    return (
      <div className="App">
        <Header />
        <div className="brand-not-found">
          <h1>Brand Not Found</h1>
          <button className="btn-primary" onClick={() => navigate('/')}>
            <ArrowLeft size={20} />
            Back to Home
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const brand = mockData.brands.find(b => b.slug === slug);

  return (
    <div className="App">
      <Header />
      
      <section className="brand-hero-section">
        <div className="container">
          <button className="back-button" onClick={() => navigate('/')}>
            <ArrowLeft size={20} />
            Back to Home
          </button>
          
          <div className="brand-hero-content">
            <div className="brand-hero-left">
              <img src={brand.image} alt={brandData.name} className="brand-hero-logo" />
              <h1 className={`brand-hero-title ${isVisible ? 'fade-in-up' : ''}`}>
                {brandData.name}
              </h1>
              <p className={`brand-country ${isVisible ? 'fade-in-up delay-1' : ''}`}>
                {brandData.country}
              </p>
              <p className={`brand-tagline ${isVisible ? 'fade-in-up delay-2' : ''}`}>
                {brandData.tagline}
              </p>
            </div>
            
            <div className="brand-hero-right">
              <img 
                src={brandData.images[0]} 
                alt={`${brandData.name} showcase`}
                className="brand-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="brand-description-section">
        <div className="container">
          <p className="brand-description">{brandData.description}</p>
        </div>
      </section>

      <section className="brand-specialties-section">
        <div className="container">
          <h2 className="section-title">Our Specialties</h2>
          <div className="brand-specialties-grid">
            {brandData.specialties.map((specialty, index) => (
              <div key={index} className="specialty-item">
                <CheckCircle size={24} className="specialty-icon" />
                <span>{specialty}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-gallery-section">
        <div className="container">
          <h2 className="section-title">Our Work</h2>
          <div className="brand-gallery-grid">
            {brandData.images.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`${brandData.name} project ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-stats-section">
        <div className="container">
          <div className="brand-stats-grid">
            {Object.entries(brandData.stats).map(([key, value], index) => (
              <div key={index} className="brand-stat-card">
                <div className="brand-stat-value">{value}</div>
                <div className="brand-stat-label">
                  {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-cta-section">
        <div className="container">
          <h2>Interested in {brandData.name}?</h2>
          <p>Get in touch to learn more about our solutions</p>
          <button 
            className="btn-primary"
            onClick={() => navigate('/#contact')}
          >
            Contact Us
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};